export const TLDs: Set<string> = new Set([
  'aero',
  'asia',
  'cat',
  'com',
  'jobs',
  'tel',
  'org',
  'net',
  'edu',
  'gov',
  'mil',
  'int',
  'app',
  'blog',
  'shop',
  'site',
  'online',
  'info',
  'biz',
  'pro',
  'me',
  'xyz',
  'tech',
  'us',
  'uk',
  'ca',
  'au',
  'de',
  'fr',
  'jp',
  'cn',
  'in',
  'ru',
  'it',
  'es',
  'br',
  'kr',
  'mx',
  'za',
  'nl',
  'se',
  'no',
  'fi',
  'dk',
  'ie',
  'pl',
  'cz',
  'ch',
  'at',
  'be',
  'nz',
  'sg',
  'hk',
  'ar',
  'cl',
  'co',
  'pe',
  've',
  'ph',
  'my',
  'th',
  'vn',
  'id',
  'eg',
  'sa',
  'ae',
  'il',
  'is',
  'pk',
  'gl',
  'bd',
  'ng',
  'ke',
  'gh',
  'tz',
  'zm',
  'zw',
  'io',
  'co',
  'tv',
  'ai',
  'fm',
  'ly',
  'gg',
])
